// src/Montaan/MainView/index.tsx

export { default } from './MainView';
